import React from 'react'
import { CARD_IMAGE, CLASSNAMES_BASED_ON_CARD, TABLE_HEADINGS, TABLE_HEADINGS_FOR_ARCTRYX } from './constants'
import SVGIcons from '../../../../../../Components/SVGIcons'
import { NO_DATA_MESSAGE } from '../../constants'
import { FEEDBACK_360_SURVEY } from '../../../../../../../config/questionTypeConstants'


export default function VisualizationCard(props) {

    //call this function if it needs the color for the line.

    const getColoredClassname = (currentRow) => {
        if (props.projectType !== FEEDBACK_360_SURVEY.DYNAMIC_360_APPLIED_MATERIALS) {
            if (currentRow.isIncludedInStrength) {
                return "strength"
            }
            else if (currentRow.isIncludedInImprovement) {
                return "improvement"
            }
            return ""
        }
        return ""


    }

    const getTableHeaders = () => {
        if (props.projectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX) {
            return TABLE_HEADINGS_FOR_ARCTRYX

        }
        else return TABLE_HEADINGS
    }


    return (
        <div className={`matrixvisulaization-card ${CLASSNAMES_BASED_ON_CARD[props.currentKey]}`}>
            <div className='matrixvisulaization-card__head'>
                <h3>  <div className='iconbx'><img src={CARD_IMAGE[props.currentKey]}></img></div> {props.currentData.title ? props.currentData.title : ""}</h3> 
               {/* 
               
               SVG-tick
               SVG-treasures
               SVG-career-barriers
               SVG-blindspots
               */}
            </div>
            <table className='matrixvisulaization-card__table'>
                {TABLE_HEADINGS.map((item) =>
                        <th  className='matrixvisulaization-card__table--head'>
                            {item.title}
                        </th>)}

                {props.currentData && props.currentData.tableValues.length > 0 ? props.currentData.tableValues.map((currentRow) =>
                    <tr className={`matrixvisulaization-card__table--top`}>
                            <td width={150} >{currentRow.category}</td>
                            <td className='matrixvisulaization-card__table--left'>{currentRow.behaviour}</td>
                        <td width={100} >{currentRow.allButSelf}</td>
                        <td  >{currentRow.self}</td>
                    </tr>) : <tr className="nodata"><td className='' height={100} colSpan={4}>{NO_DATA_MESSAGE}</td></tr>
                }
            </table>

        </div>
    )
}
